module.exports = __webpack_public_path__ + "static/bluestartaggie-1a2293826114b7c80f05090309e0b778.png";